// extracted by mini-css-extract-plugin
export default {"formList":"index_formList_LksM3","formHorizontal":"index_formHorizontal_uJS83"};